import { Mail } from "lucide-react";
import { useLang } from "@/i18n";

const CONTACTS = [
  { label_tr: "Genel destek", label_en: "General support", email: "support@loftpress.co" },
  { label_tr: "Teknik destek", label_en: "Technical support", email: "support@loftpress.co" },
  { label_tr: "Faturalandırma", label_en: "Billing", email: "billing@loftpress.co" },
  { label_tr: "Gizlilik", label_en: "Privacy", email: "privacy@loftpress.co" },
  { label_tr: "Hukuk", label_en: "Legal", email: "legal@loftpress.co" },
];

export default function Contact() {
  const { lang } = useLang();
  const t = (tr, en) => (lang === "tr" ? tr : en);
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="contact-page">
      <div className="flex items-center gap-3 mb-6">
        <Mail className="text-red-500" size={28} />
        <span className="eyebrow text-red-500">İLETİŞİM · Loft Press Ltd</span>
      </div>
      <h1 className="headline text-5xl sm:text-6xl text-white">
        {t("İletişim", "Contact")}
      </h1>
      <p className="mt-6 text-lg text-neutral-300 leading-relaxed max-w-2xl">
        {t(
          "Sorularınız için ekibimize aşağıdaki e-posta adreslerinden ulaşabilirsiniz. Genelde 24 saat içinde yanıtlıyoruz.",
          "You may reach our team at the addresses below. We typically respond within 24 hours."
        )}
      </p>

      <div className="mt-10 bg-neutral-950 border border-neutral-800 rounded-sm">
        <dl className="divide-y divide-neutral-800">
          {CONTACTS.map((c) => (
            <div key={c.email + c.label_en} className="px-6 py-4 flex items-center justify-between" data-testid={`contact-row-${c.email}`}>
              <dt className="font-mono uppercase tracking-wider text-xs text-neutral-500">
                {lang === "tr" ? c.label_tr : c.label_en}
              </dt>
              <dd>
                <a href={`mailto:${c.email}`} className="font-mono text-sm text-red-400 hover:text-red-300">
                  {c.email}
                </a>
              </dd>
            </div>
          ))}
        </dl>
      </div>

      <p className="mt-10 text-sm text-neutral-500">
        {t("Şirket adı:", "Company name:")}{" "}
        <span className="text-white font-mono">Loft Press Ltd</span>
      </p>
    </div>
  );
}
